export default {
  LOAD_JOB (state, payload) {
    state.job = payload
  },
  LOAD_JOB_USER_OBJECT (state, payload) {
    state.userObject = payload || {}
  },
  LOAD_JOB_APPLICANT_ENROLLMENT_DATA (state, payload) {
    state.applicantEnrollment = payload || []
  }

}



// WEBPACK FOOTER //
// ./src/app/job/vuex/mutations.js